export class MagicBoxRuleExtract {
  LanguageId: number;
  LanguageName: string;
  DestinationFieldId: number;
  DestinationId: number;
  DestinationName: string;
  FieldId: number;
  FieldName: string;
  SportId: number;
  SportName: string;
  CompetitionId: number;
  CompetitionName: string;
  EventId: number;
  EventName: string;
  RoundId: number;
  RoundName: string;
  DisciplinId: number;
  DisciplinName: string;
  GenderId: number;
  GenderName: string;
  AgeId: number;
  AgeName: string;
  Expression: string;

  constructor(data: any) {
    Object.assign(this, data);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/magicboxRuleExtract.ts